import localeNl from '@angular/common/locales/nl';
import localeZH from '@angular/common/locales/zh';
import {CommonModule, registerLocaleData} from '@angular/common';
import {EffectsModule} from '@ngrx/effects';
import {HttpClientModule} from '@angular/common/http';
import {MissingTranslationHandler, TranslateModule} from '@ngx-translate/core';
import {NgModule} from '@angular/core';

import {BackendMockModule} from '@ispm-client/modules/backend-mock-modules/backend-mock-service';
import {CoreComponents, CoreServices} from './index';
import {EntityEffect} from './store/entity.effect';
import {HttpClient} from '@ispm-client/modules/core/services/http-client';
import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';
import {IspmRevisionContextHttpClient} from '@ispm/core/services/ispm-revision-context-http-client';
import {RevisionContextHttpClient} from '@ispm-client/modules/core/services/revision-context-http-client';
import {environment} from '../../environments/environment';

import {
  CoreMissingTranslationHandler,
  NotTranslatedService
} from '@ispm/core/services/core-missing-translation-handler.service';

registerLocaleData(localeNl, 'nl');
registerLocaleData(localeZH, 'zh');

/**
 * BackendMockModule must be imported after HttpClientModule and in the same module we provide other HttpClient classes in order to intercepts their rest calls.
 */

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      missingTranslationHandler : {
        provide: MissingTranslationHandler,
        useClass: CoreMissingTranslationHandler,
        deps: [NotTranslatedService]}
    }),
    EffectsModule.forFeature([EntityEffect]),
    environment.production ? [] : BackendMockModule
  ],
  declarations: [...CoreComponents],
  exports: [...CoreComponents, TranslateModule, CommonModule],
  providers: [...CoreServices,
    { provide: HttpClient, useClass: IspmHttpClient},
    { provide: RevisionContextHttpClient, useClass: IspmRevisionContextHttpClient},
    { provide: HttpInterceptorService, useClass: HttpInterceptorService}
  ]
})
export class CoreModule { }
